import React, { useContext, useEffect, useRef, useState } from "react";
import styles from "./Background.module.scss";
import PathContext from "../../context/path";
import StateContext from "../../context/states";
const Background = () => {
  const path = useContext(PathContext);
  const state = useContext(StateContext);
  const { page, stage, isMobile } = state;
  const refBubble = useRef(null);
  const refWrap = useRef(null);
  const refVideo = useRef(null);
  useEffect(() => {
    refVideo.current.currentTime = 15;
    // const interBubble = refBubble.current;

    // function move(e) {
    //   if(e === undefined) return;
    //   interBubble.style.transform = `translate(${Math.round(e.clientX)}px, ${Math.round(e.clientY)}px)`;
    // }
    // window.addEventListener('mousemove', move);
  }, []);
  useEffect(() => {
    if (page === 2) {
      refWrap.current.classList = `${styles.wrap} ${styles.final}`;
    } else {
      refWrap.current.classList = `${styles.wrap} `;
    }
  }, [stage, page]);
  return (
    <>
      <div className={styles.wrap} ref={refWrap}>
        {/* <svg xmlns="http://www.w3.org/2000/svg">
          <defs>
            <filter id="goo">
              <feGaussianBlur in="SourceGraphic" stdDeviation="10" result="blur" />
              <feColorMatrix in="blur" mode="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 18 -8" result="goo" />
              <feBlend in="SourceGraphic" in2="goo" />
            </filter>
          </defs>
        </svg> */}
        <div className={styles.bubbles}>
          <div className={styles.video}>
            <video src={`${path}/img/video${isMobile ? '-mobile' : ''}.mp4`} autoPlay loop={true} tabIndex="-1" role="application" playsInline muted={true} disablePictureInPicture ref={refVideo}></video>
          </div>
          {/* <div className={`${styles.bubble} ${styles.bubble_0}`}></div>
          <div className={`${styles.bubble} ${styles.bubble_1}`}></div>
          <div className={`${styles.bubble} ${styles.bubble_2}`}></div>
          <div className={`${styles.bubble} ${styles.bubble_3}`}></div>
          <div className={`${styles.bubble} ${styles.bubble_4}`}></div>
        <div className={`${styles.bubble} ${styles.bubble_5}`} ref={refBubble}></div> */}
          <div className={`${styles.bubble} ${styles.bubble_6}`}></div>
          <div className={`${styles.bubble} ${styles.bubble_7}`}></div>
        </div>
      </div>
    </>
  );

}

export default Background;
